import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { PackageBenefitDetailsComponent } from './package-benefit-details.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [PackageBenefitDetailsComponent],
  exports: [PackageBenefitDetailsComponent],
})
export class PackageBenefitDetailsModule {}
